module.exports = __webpack_public_path__ + "img/hr-cargo-wagon-1.a3bd4fcc.png";